/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  addUser({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios
        .post("users", user)
        .then((response) => {
          console.log(user);
          commit("ADD_USER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUsers({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("users", { params: param })
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination)
            commit("SET_USERS_WITH_PAGINATION", response.data.data);
          else commit("SET_USERS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchUser({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`users/${userId}`)
        .then((response) => {
          commit("SET_USER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateUser({ commit }, item) {
    return new Promise((resolve, reject) => {
      const bodyFormData = new FormData();
      bodyFormData.append("_method", "put");
      for (const key in item) {
        if (key === "metas") {
          for (const meta_key in item.metas) {
            bodyFormData.append(`metas[${meta_key}]`, item.metas[meta_key]);
          }
        } else {
          bodyFormData.append(key, item[key]);
        }
      }
      axios
        .post(`users/${item.id}`, bodyFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          commit("UPDATE_USER", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  removeRecord({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`users/${userId}`)
        .then((response) => {
          commit("REMOVE_RECORD", userId);

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setPagination({ commit }, page) {
    commit("SET_PAGINATION", page);
  },
};
